module.exports = __webpack_public_path__ + "static/media/3.2bc69f82.png";